export default __webpack_public_path__ + "static/media/cheveron-down.d6679906.svg";